<script>
	import Navbar from "./components/Navbar.svelte";
	import Footer from "./components/Footer.svelte";
	import { api_analytics } from "./stores.js";
	import { scrollTo, scrollRef } from "svelte-scrolling";

	let totalExperiments = 11;
	let totalUsers = 15203;

	let today = new Date();
	let dd = String(today.getDate()).padStart(2, "0");
	let mm = today.toLocaleDateString("default", { month: "long" });
	let yyyy = today.getFullYear();
	today = mm + " " + dd + ", " + yyyy;

	async function analytics() {
		const resp = await fetch($api_analytics, {
			method: "POST",
			mode: "cors",
			cache: "default",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
		});
		const response = await resp.json();
		// console.log(response);
		if (response.success === "true") {
			if (
				response.total_experiments < totalExperiments ||
				response.total_users < totalUsers
			) {
				totalExperiments = 11;
				totalUsers = 15203;
			}
		} else {
			console.error("error getting analytics");
		}
		return response;
	}
	let analyticsData = analytics();
</script>

<Navbar />

<main>
	<a href="/">
		<img
			class="center-header-logo"
			src="../img/yourfeed.jpg"
			alt="Yourfeed"
		/>
	</a>

	<p>
		Yourfeed is a modular tool for ecologically valid social media research.
		Designed to mirror the design of a social media newsfeed, Yourfeed
		provides researchers with the ability to conduct studies on browsing
		behavior.
	</p>

	<p>
		As of {today},&nbsp<strong>
			{#await analyticsData then data}
				{totalExperiments}
			{:catch error}
				over {totalExperiments}
			{/await}
		</strong>
		experiments been conducted on Yourfeed, totaling
		<strong>
			{#await analyticsData then data}
				{totalUsers}
			{:catch error}
				over {totalUsers}
			{/await}
		</strong>
		users.
	</p>

	<h2>Features</h2>
	Yourfeed tracks and surfaces the dwell time of each post, a key metric from industry
	that is hard to measure in other survey platforms like Qualtrics. It is designed
	to be modular and interoperable, allowing researchers to upload their own components,
	such as stimulus/entity sets, ranking algorithms, or design interventions.

	<p>
		To learn more about Yourfeed, check out our <a
			href="https://arxiv.org/abs/2207.07478"
			target="_blank">white paper on arXiv</a
		>
		or the publications/research <a use:scrollTo={"Research"}>below</a>.
	</p>

	<p>To try out a randomly generated feed, click <a href="/">here</a>.</p>

	<p>
		To create a study, visit the <a href="/create-study/">Create Study</a> page.
	</p>

	<p>To upload entities, visit the <a href="/upload">Upload</a> page.</p>

	<p>
		To download data for an existing study, visit the <a href="/download"
			>Download</a
		> page.
	</p>

	<h3>Example dwell time metrics</h3>
	Taken from a study conducted with Yourfeed. For details, see our&nbsp<a
		href="https://arxiv.org/pdf/2207.07478.pdf"
		target="_blank">white paper on arXiv</a
	>.
	<br />

	<a href="../img/dwell.png" target="_blank">
		<img
			id="dwell-img"
			src="../img/dwell.jpg"
			alt="Dwell time metrics"
			title="Dwell time metrics"
		/>
	</a>

	<h2>Team</h2>

	Yourfeed is developed by&nbsp<a href="http://zive.info/" target="_blank"
		>Ziv Epstein</a
	>,
	<a href="https://www.hauselin.com" target="_blank">Hause Lin</a>, and Puneet
	Bhargava at the MIT Media Lab, MIT Sloan School of Management, and Cornell
	University. If you're interested in running one of the first experiments on
	Yourfeed as part of our alpha test, please fill out
	<a
		href="https://docs.google.com/forms/d/e/1FAIpQLScxUrxmKSQN3MkhjQVUwllKmiBLPGgr-eql3Pygj1SZfPA4bQ/viewform?usp=sf_link"
		target="_blank">this form</a
	>
	or email us at <a href="mailto:yourfeed@mit.edu">yourfeed@mit.edu</a>

	<div id="team-img">
		<a href="http://zive.info/" target="_blank">
			<img
				class="profile-pic-left"
				src="../img/zepstein_mondo.jpg"
				alt="Ziv Epstein"
				title="Ziv Epstein"
			/>
		</a>
		<a href="https://www.hauselin.com" target="_blank">
			<img
				class="profile-pic-center"
				src="../img/hauselin.jpg"
				alt="Hause Lin"
				title="Hause Lin"
			/>
		</a>
		<a href="" target="_blank">
			<img
				class="profile-pic-right"
				src="../img/puneetbhargava.jpg"
				alt="Puneet Bhargava"
				title="Puneet Bhargava"
			/>
		</a>
	</div>

	<section use:scrollRef={"Research"}>
		<h2 id="research">Research</h2>
		<p>
			Epstein*, Z. & Lin*, H. (2022). Yourfeed: Towards open science and
			interoperable systems for social media. <a
				href="https://arxiv.org/abs/2207.07478"
				target="_blank">https://arxiv.org/abs/2207.07478</a
			> <strong>*Yourfeed white paper</strong>
		</p>
		<p>
			Epstein*, Z., Lin*, H., Pennycook, G., & Rand, D.G. (2022). How many
			others have shared this? Experimentally investigating the effects of
			social cues on engagement, misinformation, and unpredictability on
			social media. <a
				href="https://arxiv.org/abs/2207.07562"
				target="_blank">https://arxiv.org/abs/2207.07562</a
			>
		</p>
	</section>
</main>

<Footer />

<style>
	.center-header-logo {
		width: auto;
		height: 89px;
		display: block;
		margin-left: auto;
		margin-right: auto;
	}
	#dwell-img {
		width: 89%;
		height: auto;
		display: block;
		margin-top: 8px;
		margin-left: auto;
		margin-right: auto;
	}
	#team-img {
		margin-top: 13px;
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		column-gap: 8px;
	}
	.profile-pic-left {
		width: 55%;
		display: block;
		margin-left: auto;
	}
	.profile-pic-center {
		width: 55%;
		display: block;
		margin-left: auto;
		margin-right: auto;
	}
	.profile-pic-right {
		width: 55%;
		display: block;
		margin-right: auto;
	}
	@media (max-width: 700px) {
		main {
			padding-left: 3%;
			padding-right: 3%;
		}
		.center-header-logo {
			width: auto;
			height: 34px;
		}
		#team-img {
			margin-top: 13px;
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			column-gap: 3px;
		}
		.profile-pic-left {
			width: 55%;
		}
		.profile-pic-center {
			width: 55%;
		}
		.profile-pic-right {
			width: 55%;
		}
		#dwell-img {
			width: 100%;
			height: auto;
			display: block;
			margin-left: auto;
			margin-right: auto;
		}
	}
</style>
